<script>
  document.body.style.zoom = "70%";
</script><body>
  <ng-template [ngIf]="isNavVisible">
    <nav-header ></nav-header>
  </ng-template>
  <router-outlet></router-outlet>
</body>
